export const VEGAN_ICON_COLOR = "rgb(146, 214, 146)";
export const VEGETARIAN_ICON_COLOR = "green";
